module.exports = __webpack_public_path__ + "static/media/renewable-energy.bc7363e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/renewable-energy.png
// module id = 1484
// module chunks = 0